module.exports = __webpack_public_path__ + "img/upload.4b20dbf8.svg";